module.exports = __webpack_public_path__ + "img/edge.016a47a7.png";